import { Grid } from '@mui/material';

import { CustomerStatistics } from './widgets/customer-statistics.component';
import { RecentNotes } from './widgets/recent-notes.component';
import { CustomerInfo } from './widgets/office-info.component';
import { useLoadData } from '../../../hooks/useLoadData';
import { customersApiKeyStore } from '../../../api/customers-api-key-store';
import { ApiResponse } from '../../../models/api-response';
import { Customer } from '../../../models/customer';
import { DescriptionComponent } from './widgets/description.component';

interface WidgetsContainerProps {
  customerID?: any;
}

export const WidgetsContainer = ({ customerID }: WidgetsContainerProps) => {
  const { data, isLoading } = useLoadData<ApiResponse<Customer>>(customersApiKeyStore.getCustomer(customerID));
  return (
    <Grid container justifyContent="space-between" spacing={0}>
      <Grid item lg={4}>
        <CustomerStatistics customerID={customerID} />
      </Grid>
      <Grid item lg={5} sm={5} xl={5} xs={5}>
        <CustomerInfo customer={data?.data} isLoading={isLoading} />
      </Grid>
      <Grid item lg={3} sm={3} xl={3} xs={3}>
        <Grid container spacing={2}>
          <Grid item lg={12} sm={12} xl={12} xs={12}>
            <RecentNotes customerID={customerID} />
          </Grid>
          <Grid item lg={12} sm={12} xl={12} xs={12}>
            <DescriptionComponent customer={data?.data} />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};
